// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collections-list .v-data-table>.v-data-table__wrapper tbody tr.v-data-table__expanded__content{box-shadow:none}", ""]);
// Exports
module.exports = exports;
